/**
 * Group Array objects by Key
 *
 * replace by Object.groupBy when upgraded to Node v21+
 */
export function groupArrayBy(elements, keyGetter) {
    const map = new Map();
    elements.forEach((item) => {
        const key = keyGetter(item);
        const elementsForKey = map.get(key);
        if (!elementsForKey) {
            map.set(key, [item]);
        }
        else {
            elementsForKey.push(item);
        }
    });
    return map;
}
export function groupArrayByToSingle(elements, keyGetter) {
    const map = new Map();
    elements.forEach((item) => {
        if (!map.get(keyGetter(item))) {
            map.set(keyGetter(item), item);
        }
    });
    return map;
}
export function toUniqueArray(items) {
    const itemsNotEmpty = items.filter((item) => item !== undefined && item !== null);
    return [...new Set(itemsNotEmpty)];
}
// eslint-disable-next-line
export function deepEqual(obj1, obj2) {
    if (obj1 === obj2) {
        return true;
    }
    if (!obj1 || !obj2 || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
        return false;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
            return false;
        }
    }
    return true;
}
